import { ChakraV3, useIdle } from '@piccolohealth/ui';
import { Duration } from '@piccolohealth/util';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useConfig } from '../../context/ConfigContext';

export const IdleLogoutModal = () => {
  const { config } = useConfig();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const onIdle = React.useCallback(() => {
    void navigate('/logout?reason=idle');
  }, [navigate]);

  const { isIdleWarning, idleWarningRemaining, dismissIdleWarning } = useIdle({
    idleTimeout: config.settings.idleTimeout,
    idleWarningTimeout: config.settings.idleWarningTimeout,
    onIdle,
    enabled: isAuthenticated,
  });

  if (!isIdleWarning) {
    return null;
  }

  return (
    <ChakraV3.Dialog.Root
      open={isIdleWarning}
      onOpenChange={(e) => !e.open && dismissIdleWarning()}
    >
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.Dialog.Body>
            <ChakraV3.Result
              status='warning'
              title='Session expiry warning'
              description='Your session is about to expire due to inactivity. You will be logged out in:'
              extra={
                <ChakraV3.Heading size='4xl'>
                  {Duration.fromObject({ seconds: idleWarningRemaining })
                    .shiftTo('hours', 'minutes', 'seconds')
                    .toHuman({ compactDisplay: 'short', maximumSignificantDigits: 2 })}
                </ChakraV3.Heading>
              }
              p={4}
            />
          </ChakraV3.Dialog.Body>
          <ChakraV3.Dialog.Footer>
            <ChakraV3.Button w='full' onClick={dismissIdleWarning} colorPalette='brand'>
              Continue session
            </ChakraV3.Button>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
};
